app.controller('CIFDashboard-CTRL',
    ['$scope', '$http', '$window', '$q', '$filter', 'deviceDetector',
    function ($scope, $http, $window, $q, $filter, deviceDetector) {

    $scope.CIFInvestor = {}
    $scope.clientURL = 'https://www.micropiranti.com/new/FileKYC/';
    $scope.page = '';

    $scope.datanasabah = function () {
        $window.location.href = "#/profile";
    }

    $scope.stepClass = ['', '', '', '', ''];
    $scope.txtDetail = '';
    $scope.device = deviceDetector;
    $scope.Mobile = '';

    $scope.active = "active current";

    $scope.imgMale = "";
    $scope.imgDoc = "";
    $scope.imgFemale = "";
    $scope.chkquestionfatca = 2;

    if ($scope.device.isMobile())
    {
        $scope.Mobile = 'True';
    }

    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: 'service/client.svc/retrieveSession',
            cache : false
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: 'service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: 'service/client.svc/GetPED',
            cache:false,
        }).then(function (data) {

            if (data.data.d != null) {
                $scope.broker = data.data.d;
            }
        }, function (error) { }),
    ]);


    allPromise.then(function () {
        $http({
            method: 'GET',
            url: 'service/client.svc/getCIFDetail',
            cache:false,
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;


                if ($scope.CIFInvestor.FATCA1 == 'Tidak' || $scope.CIFInvestor.FATCA2 == 'Tidak' || $scope.CIFInvestor.FATCA3 == 'Tidak') {
                    $scope.chkquestionfatca = 1;
                }

                if ($scope.CIFInvestor.State1)
                    $scope.stepClass[1] = "active current";
                    $scope.txtDetail = "Data Anda Berhasil Dikirim";

                if ($scope.CIFInvestor.State2)
                    $scope.stepClass[2] = "active current";
                    $scope.txtDetail = "Selesai Ditinjau oleh Tim Customer Service";

                if ($scope.CIFInvestor.State3)
                    $scope.stepClass[3] = "active current";
                    $scope.txtDetail = "Selesai Mendapatkan SID dan SRE";

                if ($scope.CIFInvestor.State4)
                    $scope.stepClass[4] = "active current";
                    $scope.txtDetail = "Selamat Anda Telah Mendapatkan Nomor Rekening Dana Nasabah";

                if ($scope.CIFInvestor.IsFinished == 1)
                {
                    $scope.page = 'finished'
                    
                }
                if ($scope.CIFInvestor.IsRevised == 1) {
                    $scope.page = 'revised'
                }
                if ($scope.CIFInvestor.IsFinished == 1) {
                    $scope.active = "active current";
                }

                console.log($scope.CIFInvestor);
            } // END IF data.data.d
        }, function (error) { });
    });

    $scope.login = function () {
        $window.location.href = "#/cif/data-pribadi";
    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

}]);